<template>
    <div>
        <Card>
            <div class="search-con search-con-top">
                <Form :model="form" :label-width="80" inline>
                    <FormItem label="邮箱帐号">
                        <Input v-model="form.mailAccount"></Input>
                    </FormItem>
                    <FormItem label="文件后缀">
                      <Select v-model="form.suffix">
                        <Option value="">-全部-</Option>
                        <Option :value="item.name" v-for="(item, index) in suffixsOptions" :key="index">{{item.name}}</Option>
                      </Select>
                    </FormItem>
                    <FormItem label="客户姓名">
                        <Input v-model="form.name"></Input>
                    </FormItem>
                    <FormItem label="身份证号">
                        <Input v-model="form.cardNo"></Input>
                    </FormItem>
                    <FormItem label="状态">
                      <Select v-model="form.status">
                        <Option value="">-全部-</Option>
                        <Option :value="item.key" v-for="(item, index) in statusOptions" :key="index">{{item.name}}</Option>
                      </Select>
                    </FormItem>
                    <FormItem label="申请时间">
                      <Row>
                        <Col span="11">
                          <DatePicker type="date" placeholder="开始" v-model="form.map.applyDate_st"></DatePicker>
                        </Col>
                        <Col span="2" style="text-align: center">-</Col>
                        <Col span="11">
                          <DatePicker type="date" placeholder="结束" v-model="form.map.applyDate_ed"></DatePicker>
                        </Col>
                      </Row>
                    </FormItem>
                    <FormItem label="解析时间">
                      <Row>
                        <Col span="11">
                          <DatePicker type="date" placeholder="开始" v-model="form.map.analyseDate_st"></DatePicker>
                        </Col>
                        <Col span="2" style="text-align: center">-</Col>
                        <Col span="11">
                          <DatePicker type="date" placeholder="结束" v-model="form.map.analyseDate_ed"></DatePicker>
                        </Col>
                        </Row>
                    </FormItem>

                </Form>
                <div  class="toolbar">
                   <Button @click="handleSearch" icon="md-search" class="search-btn" type="primary">搜索 </Button>
                </div>
            </div>
            <Tables ref="tables" v-model="tableData" :columns="columns" @on-search="handleSearch"
                    @on-update="handleUpdate" @on-detail="handleDetail" @on-selection-change="selectionChange"/>
        </Card>
    </div>
</template>

<script>

export default {
  name: 'mailfileinfo-list',
  data () {
    return {
      columns: [
        { title: '邮箱帐号', key: 'mailAccount' },
        { title: '邮件ID', key: 'messageId' },
        { title: '邮件发送日期', key: 'sendDate' },
        { title: '文件id', key: 'fileId' },
        { title: '文件后缀', key: 'suffix' },
        { title: '客户姓名', key: 'name' },
        { title: '身份证号', key: 'cardNo' },
        { title: '申请时间', key: 'applyDate' },
        { title: '解析时间', key: 'analyseDate' },
        {
          title: '状态',
          key: 'status',
          render: (h, params) => {
            return h('span', this.getStatusVal(params.row.status))
          }
        },
        { title: '创建时间', key: 'crtTime' },
        { title: '修改人', key: 'mdfUserId' },
        { title: '修改时间', key: 'mdfTime' }
      ],
      tableData: {
        rows: [],
        total: 0
      },
      form: {
        map: {}
      },
      statusOptions: [
        { key: -1, name: '临时' },
        { key: 0, name: '未解析' },
        { key: 1, name: '已解析' }
      ],
      suffixsOptions: [
        { key: 1, name: '.pdf' },
        { key: 2, name: '.zip' }
      ],
      selectedData: [],
      infoIsShow: false
    }
  },
  methods: {
    handleDetail (param) {
      this.$refs.mailfileinfoInfoRef.openModel('detail', param.row)
    },
    selectionChange (selection) {
      this.selectedData = selection
    },
    getStatusVal (status) {
      if (status === -1) {
        return '临时'
      } else if (status === 0) {
        return '未解析'
      } else if (status === 1) {
        return '已解析'
      } else {
        return ''
      }
    },
    handleSearch (page, pageSize) {
      if (isNaN(page)) {
        page = 1
      }
      var param = {
        page: page,
        pageSize: pageSize,
        model: this.form,
        map: this.form.map
      }
      this.L('mailfileinfo', param).then(data => {
        this.tableData = data
      })
    }
  },
  mounted () {
    this.handleSearch()
  }
}
</script>
